export function isValidUrl(url: string): boolean {
  const regex = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i;
  return regex.test(url);
}
